export default function postRss() {
  // ルートディレクトリ（index.html）でのみ実行
  if (location.pathname === "/ryozanpaku/" || location.pathname === "/ryozanpaku/index.html") {
    window.addEventListener("DOMContentLoaded", function () {
      var req = new XMLHttpRequest();

      req.onreadystatechange = function () {
        if (req.readyState === 4 && req.status === 200) {
          const postElement = document.getElementById("post");
          if (postElement) {
            postElement.innerHTML = req.responseText;
          }
        }
      };

      req.open("GET", "php/post.php");
      req.send();
    });
  }
}
